export default "/images/maintenance.svg?938d28ce46a03edf5d9303e67f1d2028";